import { combineReducers } from "redux";
import { emailAddressReducer } from "../reducers/emailaddress.reducer";
import { startDateReducer } from "../reducers/startdate.reducer";
import { basketReducer } from "../reducers/basket.reducer";
import { policyReducer } from "../reducers/policy.reducer";
import { Basket } from "../../models/basket.model";
import { productsReducer } from "../reducers/products.reducer";
import { agentReducer } from "../reducers/agent.reducer";
import { IAgent } from "../../models/agent.interface";
import { IProductState } from "../../models/product.interface";
import { IPaymentResponse } from "../../models/payment-response.interface";
import { paymentReducer } from "../reducers/payment.reducer";
import { IPolicyResponse } from "../../models/policy-response.interface";
import { IUser } from "../../models/user.interface";
import { userReducer } from "../reducers/user.reducer";
import { IUtm } from "../../models/utm.interface";
import { utmReducer } from "../reducers/utm.reducer";
import {phoneReducer} from "./phone.reducer";
import React from "react";
import {Address} from "../../components/AddressSelector/Address";
import {add} from "lodash";
import {addressReducer} from "./address.reducer";

export interface IStoreState {
  email: string;
  phone:string;
  startDate: string;
  address:Address;
  basket: Basket;
  policyResponse: IPolicyResponse | null;
  products: IProductState;
  agent: IAgent | null;
  paymentResponse: IPaymentResponse | null;
  user: IUser | null;
  utm: IUtm | null;
  children?: React.ReactNode;
}

export const initialState: IStoreState = {
  email: "",
  phone:"",
  startDate: "",
  address:new Address(),
  basket: new Basket(),
  policyResponse: null,
  products: {products:[], error: null},
  agent: null,
  paymentResponse: null,
  user: null,
  utm: { campaign: null, medium: null, source: null, adgroup: null, keyword:null, gclid:null,fallback:null, agent: "ABIB" }
};

export const rootReducer = combineReducers<IStoreState>({
  email: emailAddressReducer,
  phone:phoneReducer,
  startDate: startDateReducer,
  address:addressReducer,
  basket: basketReducer,
  policyResponse: policyReducer,
  products: productsReducer,
  agent: agentReducer,
  paymentResponse: paymentReducer,
  user: userReducer,
  utm: utmReducer
});
